module.exports = __webpack_public_path__ + "media/SendHelpTutorialVideo.5cd8e2e7.webm";